import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  fees_enabled: z.boolean(),
  fee_type: z.enum(['fixed', 'percentage']),
  amount: z.coerce.number().min(0, 'Amount must be at least 0'),
  ceiling_amount: z.coerce.number().gte(0, 'Ceiling amount must be at least 0')
});

export const FEE_TYPE = { ...FORM_SCHEMA.shape.fee_type.Values };

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  fees_enabled: false,
  fee_type: FEE_TYPE.fixed,
  amount: '',
  ceiling_amount: ''
};
